import {Component, Inject, Input} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {
    BreadCrumb,
    MX_TITLE_SERVICE_TOKEN,
    MxTitleAndBreadcrumbsService
} from '../../../../shared/services/mx-title-and-breadcrumbs.service';
import {MenuItem} from '../../services/mx-navigation-menu-elements.service';
import {MxRecentlyUsedService} from '../../services/mx-recently-used.service';

@Component({
    selector: 'mx-navigation-menu-items',
    standalone: false,
    templateUrl: './mx-navigation-menu-items.component.html',
    styleUrls: ['./mx-navigation-menu-items.component.scss']
})
export class MxNavigationMenuItemsComponent {

    @Input()
    items: MenuItem[];

    @Input()
    activeMenuPath: string;

    @Input()
    menuItemPath: string = '';

    constructor(
        private router: Router,
        public recentlyUsedService: MxRecentlyUsedService,
        @Inject(MX_TITLE_SERVICE_TOKEN) private breadCrumbService: MxTitleAndBreadcrumbsService
    ) {
    }

    goTo(item: MenuItem): void {
        if (item.externalRedirect) {
            window.open(item.link, '_blank');
        } else {
            this.router.navigate([item.link]);
        }
    }

    goToBreadcrumbLink(item: BreadCrumb): void {
        this.router.navigate([item.link], {queryParams: item.queryParam});
    }

    isActive(link: string): boolean {
        if (!this.activeMenuPath) {
            return false;
        }
       return this.activeMenuPath.includes(this.menuItemPath + '/' + link);
    }

    isActiveItem(link: string): boolean {
        if (!this.activeMenuPath) {
            return false;
        }
        return this.activeMenuPath === (this.menuItemPath + '/' + link);
    }

    getBreadCrumbs(item: MenuItem): Observable<Array<BreadCrumb>> {
        if (item.hasDynamicChildren && this.isActive(item.link.slice(1))) {
            return this.breadCrumbService.getBreadcrumbObsr();
        } else {
            return of([]);
        }
    }

    pin(breadcrumb: BreadCrumb): void {
        this.recentlyUsedService.pin(breadcrumb);
    }

    getRecentlyOpened(): Array<BreadCrumb> {
        return this.recentlyUsedService.getAllRecentlyOpened();
    }

    removeRecentlyOpened(breadcrumb: BreadCrumb): void {
        this.recentlyUsedService.removeFromRecentlyOpened(breadcrumb);
    }

    isAdded(breadcrumb: BreadCrumb): boolean {
        return this.recentlyUsedService.isAdded(breadcrumb);
    }

    isPinned(breadcrumb: BreadCrumb): boolean {
        return this.recentlyUsedService.isPinned(breadcrumb);
    }

}
